import '@babel/polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/style/global.scss';
import 'animate.css';
import domFn from '@/utils/domFn';
import EnvFn from '@/utils/env';
import Cookie from '@/utils/cookie';
import HTTP_API from '@/apis/httpApi';
import PAGE_API from '@/apis/pageApi';
import PropFn from '@/utils/vueProps';
import MethodFn from '@/utils/method';
import validateCenter from '@/utils/validateCenter';
import logBasic from './utils/logBasic';
import pay from '@/utils/pay';
// import Message from 'vue-m-message';
import VueClipboard from 'vue-clipboard2';
import del from '@/utils/delPage';
import 'beautify-scrollbar/dist/index.css';
import lazyLoadList from 'vue-lazy-load-list';
import Editor from 'vue2-ace-editor';
Vue.use(lazyLoadList);
Vue.use(Editor);
// import VueVirtualScroller from 'vue-virtual-scroller'
// Vue.use(VueVirtualScroller)

// 全局插件
import WhdsRemoteProtocal from '_slib/whdsRemoteProtocal';
// import SockJS from 'sockjs-client';
// import Stomp from 'stompjs';
// 新手引导
import VueTour from 'vue-tour';
require('vue-tour/dist/vue-tour.css');
Vue.use(VueTour);

import {
  Upload,
  Modal,
  Button,
  Icon,
  Notice,
  Progress,
  Select,
  Option,
  Switch,
  Table,
  Drawer,
  Row,
  Col,
  Form,
  Input,
  Page,
  Tabs,
  TabPane,
  FormItem,
  Tree,
  ButtonGroup,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  Tooltip,
  InputNumber,
  Split,
  Spin,
  Message,
  Poptip,
  Panel,
  Collapse,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Tag,
  Timeline,
  TimelineItem,
  Card,
  Transfer,
  Affix,
} from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.component('Split', Split);
Vue.component('Spin', Spin);
Vue.component('Upload', Upload);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('Icon', Icon);
Vue.component('Progress', Progress);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('i-switch', Switch);
Vue.component('Table', Table);
Vue.component('Drawer', Drawer);
Vue.component('Row', Row);
Vue.component('Col', Col);
Vue.component('Form', Form);
Vue.component('Input', Input);
Vue.component('Page', Page);
Vue.component('Tabs', Tabs);
Vue.component('TabPane', TabPane);
Vue.component('FormItem', FormItem);
Vue.component('Tree', Tree);
Vue.component('ButtonGroup', ButtonGroup);
Vue.component('RadioGroup', RadioGroup);
Vue.component('Radio', Radio);
Vue.component('Checkbox', Checkbox);
Vue.component('CheckboxGroup', CheckboxGroup);
Vue.component('Tooltip', Tooltip);
Vue.component('InputNumber', InputNumber);
Vue.component('Message', Message);
Vue.component('Poptip', Poptip);
Vue.component('Panel', Panel);
Vue.component('Collapse', Collapse);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Tag', Tag);
Vue.component('Timeline', Timeline);
Vue.component('TimelineItem', TimelineItem);
Vue.component('Transfer', Transfer);
Vue.component('Card', Card);
Vue.component('Affix', Affix);

Vue.prototype.$Notice = Notice;
Vue.prototype.$Message = Message;
Vue.prototype.$Modal = Modal;
// window.$msg = Message;
// 全局注入插件
Vue.prototype.$WhdsRemoteProtocal = WhdsRemoteProtocal;

// dom方法全局
Vue.prototype.$domFn = domFn;
Vue.prototype.$EnvFn = EnvFn;

Vue.prototype.$Cookie = Cookie;
// 接口api全局
Vue.prototype.$HTTP_API = HTTP_API;
// 页面地址全局
Vue.prototype.$PAGE_API = PAGE_API;
// prop全局
Vue.prototype.$PropFn = PropFn;
Vue.prototype.$MethodFn = MethodFn;

// 校验中心全局
Vue.prototype.$validateCenter = validateCenter;

Vue.prototype.$logBasic = logBasic;

// 支付
Vue.prototype.$pay = pay;
// 删除改变分页
Vue.prototype.$del = del;

Vue.use(VueClipboard);

Vue.config.productionTip = false;

// let socket = new SockJS('/ws'); //会话连接
// let stompClient = Stomp.over(socket); //使用stomp子协议的WebSocket 客户端
// stompClient.connect({}, function (frame) { //链接Web Socket的服务端
// 	// console.log(frame.body)
// 	stompClient.send("/websocketbbs/chat.addUser",
//         {},
//         JSON.stringify({sender: 'sanbao', type: 'JOIN'})
//     )
// stompClient.subscribe('/radio/data', function (respnose) { //订阅频道
// 	switch (JSON.parse(respnose.body).responseMessage) {
// 		case 'refreshTodayBarCount': //今日网吧在线总数数据更新通知
// 			that.$refs.barCount.getBarCountDataInit();
// 			break;
// 		default:
// 			break;
// 	}
// });
// });

// 全局模态窗的方法调用
window.$modal = {};
Vue.directive('myTitle', {
  inserted: function(el, binding) {
    const { value } = binding;
    // 方式1，直接给v-myTitle标签的 data-title 属性赋值
    if (el.dataset.title) {
      document.title = el.dataset.title;
    }
    // 方式2，通过指令传参（{{xxx}}）
    else if (value && value.title) {
      document.title = value.title;
    }
  },
  update(el, binding) {
    const { value } = binding;
    if (el.dataset.title) {
      document.title = el.dataset.title;
    } else if (value && value.title) {
      document.title = value.title;
    }
  },
});
window.$APP = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
